import type { ElementType } from 'react';

import type { Settings } from 'core/domains';
import { loadable } from 'ui/utilities';

type RouteComponentName = Settings['data']['routes'][number]['component'];
type PagesMapper = Record<RouteComponentName, ElementType<any>>;

/**
 * Maps Page Component names to their async loadable imports.
 *
 */
export const pagesMapper: PagesMapper = {
  PageCheckout: loadable(() => import(/* webpackChunkName: "page-checkout-v2" */ './PageCheckout')),

  PageOrderSuccess: loadable(
    () => import(/* webpackChunkName: "page-success" */ './PageOrderSuccess'),
  ),

  PageGifts: loadable(() => import(/* webpackChunkName: "page-gifts" */ './PageGifts')),

  PageSearch: loadable(() => import(/* webpackChunkName: "page-search" */ './PageSearch')),

  PageProductsByTag: loadable(
    () => import(/* webpackChunkName: "page-products-by-tag-v2" */ './PageProductsByTag'),
  ),

  PageEmptyRecommendation: loadable(
    () => import(/* webpackChunkName: "page-empty-recommendation" */ './PageEmptyRecommendation'),
  ),

  ExtendedCaptationPage: loadable(
    () => import(/* webpackChunkName: "page-extended-captation" */ './ExtendedCaptation'),
  ),

  Login: loadable(() => import(/* webpackChunkName: "login" */ './Login')),

  Logout: loadable(() => import(/* webpackChunkName: "logout" */ './Logout')),

  Faq: loadable(() => import(/* webpackChunkName: "faq" */ './FAQ')),

  PageBuilder: loadable(() => import(/* webpackChunkName: "page-builder" */ './PageBuilder')),

  Error: loadable(() => import(/* webpackChunkName: "page-error" */ './Error')),

  ErrorVDF: loadable(() => import(/* webpackChunkName: "page-error" */ './ErrorVDF')),

  MfSelfService: loadable(() => import('../mfs/MfSelfService')),

  PageTapume: loadable(() => import(/* webpackChunkName: "page-tapume" */ './PageTapume')),

  MfResellerManagement: loadable(
    () => import(/* webpackChunkName: "reseller-management" */ '../mfs/MfResellerManagement'),
  ),
  PageCategory: loadable(() => import(/* webpackChunkName: "page-category" */ './PageCategory')),

  PageProductDetail: loadable(
    () => import(/* webpackChunkName: "page-product-detail" */ './PageProductDetail'),
  ),

  RecoverPassword: loadable(
    () => import(/* webpackChunkName: "recover-password" */ './RecoverPassword'),
  ),

  RecoverPasswordEmail: loadable(
    () => import(/* webpackChunkName: "recover-email" */ './RecoverPassword/Email'),
  ),

  RecoverPasswordEmailSuccess: loadable(
    () =>
      import(
        /* webpackChunkName: "recover-email-success" */ './RecoverPassword/Email/RecoverySuccess'
      ),
  ),

  PageDepartments: loadable(
    () => import(/* webpackChunkName: "page-departments" */ './Departments/PageDepartments'),
  ),

  ResaleIntentionPage: loadable(
    () => import(/* webpackChunkName: "resale-intention" */ './ResaleIntentionPage'),
  ),

  LoadingPage: loadable(() => import(/* webpackChunkName: "loading" */ './Loading')),

  CartPage: loadable(() => import(/* webpackChunkName: "cart-page" */ './Cart/CartPage')),
};
